"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerCsvDownload = exports.getCsvFilename = exports.serializeCsv = void 0;
const sanitizeCell = (value) => {
    if (value === null || value === undefined) {
        return "";
    }
    const text = String(value);
    const escaped = text.replace(/"/g, '""');
    return `"${escaped}"`;
};
const serializeCsv = (rows, columns) => {
    const headerRow = columns
        .map((column) => sanitizeCell(column.header))
        .join(",");
    const bodyRows = rows.map((row) => columns.map((column) => sanitizeCell(column.getValue(row))).join(","));
    return [headerRow, ...bodyRows].join("\n");
};
exports.serializeCsv = serializeCsv;
const getCsvFilename = (tableName) => {
    const date = new Date().toISOString().split("T")[0];
    const sanitized = tableName
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    return `${sanitized || "table"}-${date}.csv`;
};
exports.getCsvFilename = getCsvFilename;
const triggerCsvDownload = (csv, filename) => {
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
    URL.revokeObjectURL(url);
};
exports.triggerCsvDownload = triggerCsvDownload;
